import RegionComments from './RegionComments';

export default RegionComments;
